var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Loading } from "@/shared/presentation/components/loading";
import { Center } from "@reverb-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { Route } from "react-router-dom";
import { AuthContext } from "@/shared/presentation/context-api/providers/auth";
import { useHistory } from "react-router";
export var PrivateRouteWrapper = function (_a) {
    var _b;
    var authClient = _a.authClient, props = __rest(_a, ["authClient"]);
    var _c = useState(), token = _c[0], setToken = _c[1];
    var _d = useState(false), loadingToken = _d[0], setLoadingToken = _d[1];
    var _e = useContext(AuthContext), isValidated = _e.isValidated, rockId = _e.rockId, isEntityStandalone = _e.isEntityStandalone, clientWallets = _e.clientWallets;
    var history = useHistory();
    var firstAccessRoutes = [
        "/first-access",
        "/first-access/talent",
        "/first-access/ask-to-join",
        "/first-access/company",
    ];
    var employeeMyAccountRoutes = ["/my-account/company", "/my-account/users"];
    useEffect(function () {
        setLoadingToken(true);
        var refreshToken = function () { return __awaiter(void 0, void 0, void 0, function () {
            var newToken, e_1, loginToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 4]);
                        return [4 /*yield*/, authClient.getToken()];
                    case 1:
                        newToken = _a.sent();
                        if (newToken === token) {
                            setLoadingToken(false);
                        }
                        setToken(newToken);
                        return [3 /*break*/, 4];
                    case 2:
                        e_1 = _a.sent();
                        return [4 /*yield*/, authClient.login()];
                    case 3:
                        loginToken = _a.sent();
                        setToken(loginToken);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        refreshToken();
    }, [(_b = props === null || props === void 0 ? void 0 : props.location) === null || _b === void 0 ? void 0 : _b.key]);
    useEffect(function () {
        setLoadingToken(false);
    }, [token]);
    if (!token || isValidated === undefined || loadingToken) {
        return (React.createElement(Center, { h: "100vh", bg: "gray.100" },
            React.createElement(Loading, null)));
    }
    if (token) {
        if (isValidated === false) {
            window.location.href = process.env.LOGIN_URL + "/sign-up/email-confirmation";
        }
        var path = props === null || props === void 0 ? void 0 : props.path;
        var canNotAccessFirstAccessPages = rockId && !isEntityStandalone;
        if (firstAccessRoutes.includes(path) && canNotAccessFirstAccessPages) {
            history.push("/home");
        }
        var isEmployee = !!(clientWallets === null || clientWallets === void 0 ? void 0 : clientWallets.length);
        var pathName = window.location.pathname;
        if (employeeMyAccountRoutes.includes(pathName) && !isEmployee) {
            history.push("/my-account/profile");
        }
    }
    return React.createElement(Route, __assign({}, props));
};
